module.exports = __webpack_public_path__ + "static/media/qb.103ff3dc.png";